const siteConfig = {
  siteName: "Velview Windows & Doors",
  siteUrl: "https://velview.com",
  siteLogo: "/assets/logo.png",
  siteDescription:
    "Premium uPVC Windows & Doors - Energy-efficient, durable, and secure solutions for your home.",

  seo: {
    defaultTitle: "Velview Windows & Doors - Premium uPVC Solutions",
    defaultDescription:
      "Transform your home with Velview's energy-efficient, noise-reducing, and secure uPVC windows and doors.",
    defaultKeywords: [
      "uPVC windows",
      "uPVC doors",
      "energy-efficient windows",
      "noise reduction",
      "home improvement",
      "Velview",
    ],
    defaultImage: "/assets/og-image.jpg",
  },

  contact: {
    email: "info@velview.com",
    phone: "+61 492 952 717",
    address: "470 St Kilda Road, Melbourne 3004, Victoria",
  },

  socialLinks: {
    facebook: "https://www.facebook.com/velviewwindowsdoors/",
    instagram: "https://www.instagram.com/velview_windows_doors/",
    whatsapp: "https://api.whatsapp.com/send?phone=61492952717",
    messenger: "http://m.me/463774666822035",
  },
};

export default siteConfig;
